export const appstorelinks = [
  {
    Imgsrc: '/assets/images/playStore.png',
    href: 'https://play.google.com/store/apps/details?id=uk.riide.twofourseven&hl=en',
    alt: 'Android App Store Icon',
  },
  {
    Imgsrc: '/assets/images/appleStore.png',
    href: 'https://apps.apple.com/gb/app/247-carz/id1241258685',
    alt: 'Apple Store Icon',
  },
];
